import PageHeader from 'components/pageHeader/PageHeader';
import { Trans, useTranslation } from 'react-i18next';

const ReviewsTabHeader = () => {
  const { t } = useTranslation();

  return (
    <PageHeader
      title={t('pageAutomations.reviews.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.reviews.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/5466960-automate-reviews-for-airbnb-and-vrbo-guests"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      noDivider
    />
  );
};

export default ReviewsTabHeader;
